import axios from 'axios';
import config from '../config';
import { ApproveRouteCardResponse } from '../interfaces';

export const approveRouteCard = (id: string): Promise<ApproveRouteCardResponse> => {
    return axios.post(`${config.API_URL}/route-cards/${id}/approve`, {}).then((response: any) => {
        return response.data.data;
    });
};
